import Api from "./Api"

export default {
    listar(){
        return Api().get(`/categorias`);
    },
    listarCategorias(page=1, limit, nombre){
        return Api().get(`/getCategorias?page=${page}&limit=${limit}&nombre=${nombre}`);
    },
    guardar(datos){
        return Api().post("/categoria", datos);
    },
    mostrar(id){
        return Api().get(`/categoria/${id}`);
    },
    modificar(id, datos){
        return Api().put(`/categoria/${id}`, datos);
    },
    eliminar(id){
        return Api().delete(`/categoria/${id}`);
    },
}